import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { Incident } from '../../models/Incident';
import { Card } from './Card';

interface CardListProps {
  incidents: Incident[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
  total?: number;
  selectedColumns?: string[];
  onOpenActions?: (incident: Incident) => void;
  onOpenHistory?: (incident: Incident) => void;
  couriersMap?: Map<number, any>;
}

export const CardList = ({
  incidents,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  selectedColumns,
  onOpenActions,
  onOpenHistory,
  couriersMap,
}: CardListProps) => {
  const { t } = useTranslation('incidentsModule');

  const renderCard = (props: RenderItemProps<Incident>) => (
    <Card
      incident={props.item}
      selectedColumns={selectedColumns}
      onOpenActions={onOpenActions}
      onOpenHistory={onOpenHistory}
      couriersMap={couriersMap}
    />
  );

  const getKey = (incident: Incident) => incident.id;

  return (
    <VirtualList
      data={incidents}
      renderItem={renderCard}
      itemKey={getKey}
      estimateItemHeight={180}
      height="calc(100vh - 150px)"
      gap={0}
      emptyMessage={t('list.empty', 'Sin incidencias')}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
